import { SettlementTaxWithholdingTypeEnum } from '../../../generated/api.graphql';

/** How tax withholding on a settlement is expressed. */
export const TaxWithholdingType = Object.freeze({
  FIXED: SettlementTaxWithholdingTypeEnum.Fixed,
  PERCENTAGE: SettlementTaxWithholdingTypeEnum.Percentage,
});

export type TaxWithholdingType = (typeof TaxWithholdingType)[keyof typeof TaxWithholdingType];
